/*
 * File: /src/store/modules/workflows.js
 * Created Date: Sunday April 7th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 7th April 2019 7:26:22 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import automationService from '../../services/automationService';

const state = {
  workflows: undefined, // Lazy load as needed, Once set it wont load again
  triggerTypes: undefined,
  triggerConfig: undefined,

  currentWorkflow: {}
};

const getters = {
  getWorkflows: state => state.workflows,

  // TODO: clean this all up as this is not even used anywhere
  getWorkflowsByCampaign: state => id => {
    const newWorkflowObj = [];
    for (const wf in state.workflows) {
      if (state.workflows[wf].campaign_id === parseInt(id, 10)) {
        newWorkflowObj.push(Object.assign({}, state.workflows[wf]));
      }
    }
    return newWorkflowObj;
  },
  getWorkflowNameById: state => id => {
    if (state.workflows == undefined) {
      return undefined;
    }
    for (const wf in state.workflows) {
      if (state.workflows[wf].id === parseInt(id, 10)) {
        return state.workflows[wf].name;
      }
    }
  },
  getTriggerTypes: state => state.triggerTypes,
  getTriggerConfig: state => state.triggerConfig,
  getCurrentWorkflow: state => state.currentWorkflow
};
const actions = {
  saveCurrentWorkflow({ commit }, meta) {
    return new Promise((resolve, reject) => {
      commit('setCurrentWorkflow', meta);
      resolve({ success: 1 });
    });
  },

  getWorkflowsByCampaign: ({ state }, meta) => {
    return new Promise((resolve, reject) => {
      const newWorkflowObj = [];
      for (const wf in state.workflows) {
        if (state.workflows[wf].campaign_id === meta.id) {
          newWorkflowObj.push(Object.assign({}, state.workflows[wf]));
        }
      }
      resolve(newWorkflowObj);
    });
  },

  async fetchWorkflows({ commit }) {
    if (state.workflows == undefined) {
      return automationService
        .fetchWorkflows()
        .then(d => {
          commit('setWorkflows', d.data);
        });
    }
  },
  unloadWorkflows({ commit }) {
    commit('setWorkflows', undefined);
  },
  addWorkflow: ({ commit }, wfData) => {
    return new Promise((resolve, reject) => {
      automationService
        .addWorkflow(wfData)
        .then(r => {
          resolve({ success: 1, data: r });
        })
        .catch(e => {
          reject({
            success: 0,
            error: e
          });
        });
    });
  },
  // Just throwing this in workflow store for now. We can build a trigger store
  // later if we have a need
  async fetchTriggerConfig({ commit }) {
    if (state.triggerConfig == undefined) {
      return automationService.fetchTriggerConfig().then(d => {
        commit('setTriggerConfig', d.data);
      });
    }
  },
  unloadTriggerConfig({ commit }) {
    commit('setTriggerConfig', undefined);
  },
};
const mutations = {
  setWorkflows(state, workflows) {
    state.workflows = workflows;
    // state.workflows = Object.assign({}, workflows);
  },
  setTriggerConfig(state, config) {
    if (config == undefined) {
      state.triggerTypes = undefined;
      state.triggerConfig = undefined;
      return;
    }
    state.triggerTypes = Object.assign({}, config.types);
    state.triggerConfig = Object.assign({}, config.config);
  },

  setCurrentWorkflow(state, workflow) {
    state.currentWorkflow = Object.assign({}, workflow);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
